import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import { fetchCategories } from '../../action/goods';
import { connect } from 'react-redux';
import { isEmpty } from 'lodash';
import Loader from '../utils/Loader';
import { fetchFilials, fetchPayments } from '../../action/handbook';
import { fetchSettings } from '../../action/app';
import { fromStore } from '../../selectors';
import OrderRow from './OrderRow';
import ErrorBoundary from '../utils/ErrorBoundary';

const styles = {
    loading: {
        minHeight: '500px',
        display: 'flex',
        justifyContent: 'center'
    }
}

const paymentTitle = {
    cash: 'Наличные',
    terminal: 'Терминал',
    online: 'Онлайн-оплата',
    paymented: 'Оплачен',
    YE: 'Яндекс',
    DC: 'Деливери',
};


class OrdersTable extends Component {
    constructor(props) {
        super(props);
        this.state = {
          openClient: false,
        };
    }
    
    componentDidMount(){
        if(isEmpty(this.props.settings))        
            this.props.fetchSettings();
        if(isEmpty(this.props.filials)) this.props.fetchFilials(null);
        if(isEmpty(this.props.categories)) this.props.fetchCategories();

        const getPayments = async () => {
            await Promise.all([
                this.props.fetchPayments(true)
            ]);
            this.props.payments.map((payment) => {
                return paymentTitle[payment.Name] = payment.VisibleName;
            });
        }

        if(window.location.pathname.includes('/clients'))
        {
            this.setState({openClient: true})
        } else {
            this.setState({openClient: false})
        }

        getPayments();
    }

    renderBody() { 
        return (
            <tbody className="kt-datatable__body order_table">
                {
                    this.props.items.length === 0 && (
                        <tr className="kt-datatable__row order_table">
                            <td className="kt-datatable__cell order_table">Заказов не найдено</td>
                        </tr>
                    )
                }
                { this.props.items.map((item) => (
                    <ErrorBoundary key={item.id} fallback={<tr className='kt-datatable__row order_table new'>{`Не удалось отобразить заказ №${item.id}. Попробуйте позже.`}</tr>}>
                        <OrderRow 
                            key={item.id}
                            order={item} 
                            openClient={this.state.openClient} 
                            paymentTitle={paymentTitle}
                            isArchive={this.props.isArchive}
                            onDelete={this.props.onDelete}
                            platforms={this.props.platforms}
                        />
                    </ErrorBoundary>
                ))}
            </tbody>
        );
    }

    render() {
        if(this.props.loading)
            return (
                <div style={styles.loading}><Loader /></div>
            );

        return (
            <table className="kt-datatable__table" style={{ minHeight: '500px', backgroundColor: '#00000000', overflow: 'visible' }}>
                {this.renderBody()} 
            </table>
        );
    }
}

const mapStateToProps = state => ({
    loading: state.loaders.orders || state.loaders.filials || state.loaders.settings || fromStore.loaderCategoriesSelector(state),
    settings: state.settings.init.categories,
    categories: fromStore.categoryListSelector(state),
    payments: state.handbook.payments,
});

const mapDispatchToProps = {
    fetchFilials: (city) => fetchFilials(city, true),
    fetchSettings: () => fetchSettings(),
    fetchCategories: () => fetchCategories(),
    fetchPayments: (isGetAll) => fetchPayments(isGetAll),
};

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(OrdersTable));